/* eslint-disable no-dupe-keys */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import Button from 'components/base/Button';
import PhoenixOffcanvas from 'components/base/PhoenixOffcanvas';
import Unicon from 'components/base/Unicon';
import { UilTimes } from '@iconscout/react-unicons';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';
import useAdvanceTable from 'hooks/useAdvanceTable';
import SearchBox from 'components/common/SearchBox';
import AdvanceTableProvider, {
  useAdvanceTableContext
} from 'providers/AdvanceTableProvider';
import Avatar from 'components/base/Avatar';
import { Icon } from '@iconify/react';
import Divider from 'components/custom/ui/Divider';
import Badge from 'components/base/Badge';
import { useNavigate } from 'react-router-dom';
import { hrmsPaths } from 'constants/pagePath';

const driverListViewColumn = [
  {
    accessorKey: 'employee_status',
    header: 'Status'
  },
  {
    accessorKey: 'first_name',
    header: 'Employee Name'
  },

  {
    accessorKey: 'employee_mobile',
    header: 'Employee Mobile'
  },
  {
    accessorKey: 'designation_name',
    header: 'Designation Name',
    accessorFn: ({ designation_name }) =>
      `${designation_name || 'Not Assigned'}`
  }
];

const EmployeeListViewOffcanvas = ({ open, setOpen, employeeId, data }) => {
  const navigate = useNavigate();
  const table = useAdvanceTable({
    data: data,
    selection: false,
    columns: driverListViewColumn,
    // pageSize: 28,
    pagination: false,
    sortable: true
  });

  const handleSearchInputChange = e => {
    table.setGlobalFilter(e.target.value || undefined);
  };

  const handleViewDetail = id => {
    navigate(`${hrmsPaths.employee.detail(id)}`);
    setOpen(false);
  };
  return (
    <>
      <PhoenixOffcanvas
        open={open}
        onHide={() => setOpen(false)}
        style={{ maxWidth: 460 }}
        className="p-4 pt-3 phoenix-offcanvas-content scrollbar"
        placement="end"
        fixed
      >
        <div>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h3 className="mb-0">Employee</h3>
            <Button className="p-0" onClick={() => setOpen(false)}>
              <Unicon icon={UilTimes} />
            </Button>
          </div>
          <AdvanceTableProvider {...table}>
            <Row className="g-3 mb-6">
              <Col xs={12}>
                <SearchBox
                  className="w-100"
                  placeholder="Search employee"
                  onChange={handleSearchInputChange}
                />
              </Col>
              <Col xs={12}>
                <EmployeeListItem
                  // handleViewDetail={handleViewDetail}
                  employeeId={employeeId}
                  handleViewDetail={handleViewDetail}
                  driverId={employeeId}
                />
              </Col>
            </Row>
          </AdvanceTableProvider>
        </div>
      </PhoenixOffcanvas>
    </>
  );
};

const EmployeeListItem = ({ employeeId, handleViewDetail }) => {
  const table = useAdvanceTableContext();
  const { getFilteredRowModel } = table;
  const rows = getFilteredRowModel().rows;
  return (
    <div className="d-flex flex-column gap-2 px-2">
      {rows?.length > 0 ? (
        <>
          {rows.map(({ original }, i) => {
            return (
              <div
                key={`listDriver-${i}`}
                className={`card card-body p-2 cursor-pointer ${
                  employeeId == original.employee_id
                    ? 'border border-primary'
                    : ''
                }`}
                onClick={() => handleViewDetail(original.employee_id)}
              >
                <div className="d-flex align-items-center">
                  <Avatar
                    src={original.employee_image}
                    size="xl"
                    className="me-3 flex-shrink-0"
                  />
                  <div>
                    <p className="text-1000 mb-0 fs-8 fw-bold">
                      {original.first_name}
                    </p>
                    <div className="d-flex align-items-center flex-wrap">
                      <p className="fs-9 me-2 mb-0 pe-lg-2 border-end-lg border-300">
                        <Badge
                          iconPosition="start"
                          variant="phoenix"
                          bg={original.percentage == 100 ? 'success' : 'danger'}
                          className="pb-1"
                          icon={
                            <Icon
                              className={`text-${original.percentage == 100 ? 'success' : 'danger'} me-1`}
                              fontSize="8px"
                              icon={'streamline:circle-solid'}
                            />
                          }
                        >
                          {original.percentage === 100
                            ? original.change_flag !== 1
                              ? original.employee_status
                              : 'Approval Pending'
                            : 'Incomplete Detail'}
                        </Badge>
                      </p>

                      <p
                        className={`text-700 fs-9 me-2 mb-0 pe-lg-2 border-end-lg border-300 mb-0 d-flex align-items-center gap-1`}
                      >
                        <Icon
                          icon={'line-md:phone'}
                          fontSize="16px"
                          className="text-primary"
                        />
                        {original.employee_mobile}
                      </p>
                      <p
                        className={`text-700 fs-9 me-2 mb-0 d-flex align-items-center gap-1`}
                      >
                        <Icon
                          icon={'mdi-user'}
                          fontSize="16px"
                          className="text-primary"
                        />
                        {original.designation_name || 'Not Assigned'}
                      </p>
                    </div>
                  </div>
                </div>

                {original.change_flag === '1' ? (
                  <div>
                    <Divider
                      variant="solid"
                      color="gray-200"
                      className="my-2"
                    />
                    <p className="mb-0 fs-10 text-warning">
                      <Icon icon={'fluent:warning-32-filled'} fontSize="14px" />{' '}
                      This driver is pending approval.
                    </p>
                  </div>
                ) : null}
              </div>
            );
          })}
        </>
      ) : (
        <div className="text-danger text-center">No records found</div>
      )}
    </div>
  );
};

export default EmployeeListViewOffcanvas;
